import initialState from "./initialState";
import * as types from "../actions/actionTypes";
import { companyDataState } from "../types/reduxState";

interface appActions {
  type: string;
  payload: any;
}

function createData(
    fullName: string,
    email: string,
    company_name: string,
    companyRole : string,
    phoneNumber: string,
    status: string,
    id: number

): CompanyData {
  return {
    fullName,
    email,
    company_name,
    companyRole,
    phoneNumber,
    status,
    id
  };
}


interface CompanyData {
   fullName: string;
   email: string;
   company_name: string;
   companyRole : string;
   phoneNumber: string;
   status: boolean | string;
   id: number;
}

function convertApiToTableData(apiResponse: any) {
  return apiResponse.map((user: any) =>
    createData(
        user.fullName,
        user.email,
        user.company_name,
        user.roleName || user.companyRole,
        user.phoneNumber,
        user?.isActive,
        user.id,
    )
  );
}


export default function userReducer(currentState: companyDataState, action: appActions): any {
  const state = currentState || initialState.companyList;
  switch (action.type) {
    case types.SET_USER_LIST:
      // data is converted to deepcopt json to avoid reference issues
      const data = JSON.parse(JSON.stringify(convertApiToTableData(action.payload.records)));
      return {
        ...state,
        list: action.payload.records?.length ? data : [],
        page: action.payload.page,
        rowsPerPage: action.payload.fetchSize,
        totalCount: action.payload.totalRecords,
      };
    case types.SET_USER_LIST_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case types.SET_USER_LIST_ROWS_PER_PAGE:
      return {
        ...state,
        rowsPerPage: action.payload,
        page: 1,
      };
    case types.SET_USER_LIST_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case types.SET_COMPANY_USER_LIST:
      return {
        ...state,
        companyList: action.payload?.length ? action.payload : [],
      };
    default:
      return state;
  }
}
